<template>
  <item-container>
    <template v-slot:default>
      <display-field
        :readonly="true"
        :primary="true"
        :value="item.name"
      ></display-field>

      <span class="ml-1 relative md:-t-px">
        <labelled-icon
          icon="mask"
          :class="[$options.$styles.iconButtons, ` max-md:py-2 `]"
          textClasses=" max-md:hidden "
        >
          disguise
        </labelled-icon>
      </span>

      <span class="ml-1 relative md:-t-px">
        <stats-link
          collection="bestiary"
          title="View template stats"
          textClasses=" max-md:hidden "
          :id="item.name"
          :class="[$options.$styles.iconButtons, ` max-md:py-2 `]"
        >
          stats
        </stats-link>
      </span>

      <div class="flex-0 flex justify-end relative ml-4" v-if="battle">
        <field
          class="max-sm:hidden relative
  md:-t-px"
          :value="amount"
          @input="input => (amount = input * 1)"
          type="number"
        >
          Add:
        </field>
        <button
          type="button"
          class="o-obvious-button whitespace-no-wrap -ml-px max-md:py-1"
          @click="add"
        >
          <span class="sm:hidden text-lg">+</span
          ><span class="max-sm:hidden"
            >to<span class="hidden lg:inline"> current</span> battle</span
          >
        </button>
      </div>
      <fader>
        <div
          v-if="added"
          class=" absolute t-half l-full text-xs leading-none px-2 uppercase -y-half "
        >
          <span class="mr-px text-accent">✔︎</span>&nbsp;{{ added }}
        </div>
      </fader>
    </template>

    <template v-slot:secondary> </template>
  </item-container>
</template>

<script>
import StatsLink from '@/components/StatsLink'
import DisplayField from '@/components/DisplayField'
import ItemContainer from '@/components/ItemContainer'
import LabelledFieldInput from '@/components/LabelledFieldInput'
import LabelledIcon from '@/components/LabelledIcon'

import { mapGetters, mapActions } from 'vuex'
import { iconButtons } from '@/utilities/styles'

export default {
  name: `BestiaryItem`,

  data() {
    return {
      amount: 1,
      added: 0,
    }
  },

  components: {
    StatsLink,
    DisplayField,
    field: LabelledFieldInput,
    LabelledIcon,
    ItemContainer,
  },

  props: {
    item: {
      type: Object,
      required: true,
      validator: function({
        challenge_rating,
        dexterity,
        id,
        name,
        slug,
        type,
      }) {
        return (
          typeof id === `string` &&
          id !== `` &&
          typeof name === `string` &&
          name !== `` &&
          typeof slug === `string` &&
          slug !== `` &&
          (typeof dexterity === `undefined` || Number.isInteger(dexterity)) &&
          typeof challenge_rating === `string` &&
          challenge_rating !== `` &&
          typeof type === `string` &&
          type !== ``
        )
      },
    },
  },

  computed: {
    ...mapGetters(`battles`, [`battle`]),
  },

  methods: {
    ...mapActions(`bestiary`, [`addToBattle`]),

    add() {
      this.addToBattle({
        data: this.item,
        amount: this.amount,
        added: this.added,
      })
      // add amount of monster to battle, then…
      this.added += this.amount
    },
  },

  $styles: {
    iconButtons,
  },
}
</script>
